
import { useNavigate, useParams } from "react-router-dom"
import React, { useState, useEffect } from 'react'
import { Box, Card, Container, Grid, Typography } from "@mui/material"
import api from "../../../../services/api";
import { useDispatch, useSelector } from 'react-redux';
import Date from "../../../../utils/date";
import HeaderSession from "../../../../utils/headerSession";
import TextoFormatado from "../../../../utils/textoFormatado";
import ResponseExpediente from "./responseExpediente";
import CreateObservacaoExpediente from "./createObservacaoExpediente";
import { makeStyles } from "@material-ui/core";
import NavLateral from "./navLateral";
import PreviewAnexos from "../../../../utils/PreviewAnexos";
import InfoFieldGroup from "../../../../utils/InfoField/InfoFieldGroup";
import DateHora from "../../../../utils/dateHora";
import { temPermissao } from "../../../../utils/permissoes";
import ProcessoLoading from "../../../../load/processoLoading";
import QRCodeExpediente from "./qrCodeExpediente";

const useStyles = makeStyles((theme) => ({
    grid1: {
        width: 300,
        marginLeft: "auto",
        marginRight: "auto",

        [theme.breakpoints.up("md")]: {
            // width: '100%',
            height: "100%",
            position: "sticky",
            top: 70,
        },
    },
    grid2: {
        flexGrow: 1,
        marginLeft: 15,
        width: 500,
        zIndex: 1,
    },
}));

export default function GestExpediente({ element: component, ...rest }) {
    const baseUrl = window.location.origin;
    const classes = useStyles();
    let { id } = useParams()
    const dispatch = useDispatch();
    const [expediente, setExpediente] = useState('')
    const user = useSelector(state => state.account.user);
    const [update, setUpdate] = useState(false)
    const navigate = useNavigate();

    const [previewFiles, setPreviewFiles] = useState([]);
    const [currentFileIndex, setCurrentFileIndex] = useState(0);
    const [previewOpen, setPreviewOpen] = useState(false);


    const handleOpenPreview = (documents, fileIndex = 0) => {
        const valid = documents.filter((d) => typeof d === "string" && d.trim() !== "");
        if (!valid.length) return;
        setPreviewFiles(valid);
        setCurrentFileIndex(fileIndex);
        setPreviewOpen(true);
    };

    const handleClosePreview = () => setPreviewOpen(false);

    const handleNavigate = (index) => {
        if (index >= 0 && index < previewFiles.length) {
            setCurrentFileIndex(index);
        }
    };

    useEffect(() => {
        api.get(`/expediente/${id}`)
            .then(response => {
                // console.log(response)
           
                if (!temPermissao(user, [response.data.expediente.status])) {
                    dispatch({
                        type: "alert",
                        payload: { alert: "Acesso negado" },
                    });
                    navigate("/admin/menu");
                }

                setExpediente(response.data.expediente);
            }).catch(error => {
                // console.log(error)
                // if (error.response.status === 500) {
                //     setMessageError('Reclamação não encontrada')
                //     window.setTimeout(() => {
                //         navigate(-1)
                //     }, 1000);
                // }
            })
    }, [id, update])

    // console.log(expediente)

    return (expediente ?

        <Container>
            <HeaderSession title={'GESTÃO DE EXPEDIENTE'} />

            <Grid container>
                <Grid item className={classes.grid1}>
                    <NavLateral
                        observacoesFeitas={expediente?.observacoes}
                        expediente={expediente}
                        setUpdate={setUpdate}
                    />
                </Grid>

                <Grid xs item className={classes.grid2} style={{ marginLeft: 15 }}>


                    <Card style={{ padding: 20, marginBottom: 10, }}>

                        {component &&
                            React.cloneElement(component, {
                                expediente: expediente,
                                setUpdate: setUpdate
                            })
                        }

                        <InfoFieldGroup
                            // submit={submitEdit}
                            // data={editDados}
                            // handleChange={handleChange}
                            // setIsEdit={setIsEdit}
                            // isEdit={isEdit}
                            // load={load}
                            fields={
                                [
                                    { label: 'Localização', value: expediente?.status, editable: false, },
                                    { label: 'Nome', value: expediente?.nome, key: 'nome', onChange: '(v) => setEditDados({ ...editDados, nome: v.target.value })' },
                                    // { label: 'Nº de Identificação', value: expediente?.nifBi, key: 'nome', onChange: '(v) => setEditDados({ ...editDados, nifBi: v.target.value })' },
                                    { label: 'Nº Registo', value: expediente?.numero, key: 'numero', onChange: '(v) => setEditDados({ ...editDados, numero: v.target.value })' },
                                    { label: 'Portador / Remetente', value: expediente?.remetidoPor?.nome, key: 'remetidoPor', onChange: '(v) => setEditDados({ ...editDados, remetidoPor: v.target.value })' },
                                    { label: 'Tipo de Documento', value: expediente?.tipoDocumento?.designacao, key: 'tipoDocumento', onChange: '(v) => setEditDados({ ...editDados, tipoDocumento: v.target.value })' },
                                    { label: 'Tipo de Remetente', value: expediente?.tipoRemetente, key: 'tipoRemetente', onChange: '(v) => setEditDados({ ...editDados, tipoRemetente: v.target.value })' },
                                    { label: 'Nº do Documento', value: expediente?.numeroDocumento, key: 'numeroDocumento', onChange: '(v) => setEditDados({ ...editDados, numeroDocumento: v.target.value })' },
                                    { label: 'Assunto', value: expediente?.assunto, key: 'assunto', onChange: '(v) => setEditDados({ ...editDados, assunto: v.target.value })' },
                                    { label: 'Data do Documento', value: <Date date={expediente?.dataAnexo} />, key: 'dataAnexo' },
                                    { label: 'Email', value: expediente?.email, key: 'email', onChange: '(v) => setEditDados({ ...editDados, email: v.target.value })' },
                                    { label: 'Contacto', value: expediente?.tel, key: 'tel', onChange: '(v) => setEditDados({ ...editDados, tel: v.target.value })' },
                                    { label: 'Registado Por', value: expediente?.admin?.dadosPessoais?.nome, key: 'user', onChange: '(v) => setEditDados({ ...editDados, userId: v.target.value })' },
                                    { label: 'Data Registo', value: <DateHora date={expediente?.createdAt} />, key: 'createdAt' },
                                    { label: 'Ultima Intervenção', value: <DateHora date={expediente?.updatedAt} />, key: 'updatedAt' },
                                ]
                            } />
                    </Card>

                    <Card style={{ padding: 20, marginBottom: 10, }}>
                        <Box sx={{ backgroundColor: 'rgba(0, 0, 0, 0.03)', padding: '2rem', borderRadius: '4px', mb: 4 }}>
                            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1">
                                <strong>Exposição:</strong>
                            </Typography>
                            <TextoFormatado texto={expediente?.descricao ?? ''} />
                        </Box>
                    </Card>

                    <Card style={{ padding: 20 }}>
                        <Typography variant="subtitle1" style={{ margin: 10 }}>
                            Documento anexado nº {expediente?.numeroDocumento}
                            <br />
                            <a target="_blank" onClick={(e) => {
                                e.preventDefault();
                                handleOpenPreview([expediente?.anexo], 0);
                            }}>{expediente?.anexo ? 'Anexo' : ''} </a>
                        </Typography>
                        <iframe
                            id="pdfIframeExpediente"
                            title={`PDF Viewer`}
                            src={[expediente?.anexo]}
                            width="100%"
                            height="700px"
                            style={{ border: 'none' }}
                        />
                    </Card>

                    <CreateObservacaoExpediente
                        userId={user?._id}
                        expedienteId={id}
                        observacoes={expediente?.observacoes}
                        setUpdate={setUpdate}
                    />

                    <ResponseExpediente
                        userId={user?._id}
                        expediente={expediente}
                        setUpdate={setUpdate}
                    />

                    <Card style={{ marginTop: 10, padding: 20 }}>
                        <QRCodeExpediente header={true} link={`${baseUrl}/admin/expediente/view/${id}`} expediente={expediente} />
                    </Card>

                </Grid>
            </Grid>

            <PreviewAnexos
                files={previewFiles}
                currentIndex={currentFileIndex}
                isOpen={previewOpen}
                onClose={handleClosePreview}
                onNavigate={handleNavigate}
            />

        </Container>
        :
        <ProcessoLoading />
    )
}